import type { RouteRecordRaw } from 'vue-router';

import { computed } from 'vue';

import { useGlobalI18n } from '@abaninja/util-i18n';

const { global: { t } } = useGlobalI18n();

export const routes: RouteRecordRaw[] = [
  {
    path: 'peppershop',
    children: [

      {
        name: 'peppershop-config',
        path: 'config',
        component: () => import('../PeppershopConfigIndex.vue'),
        meta: {
          permissions: ['ADMIN'],
          title: computed(() => t('messages.shopConfig')),
        },
      },
    ],
  },
];
